import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/CreateGiftCard/createGiftCard.container"
    ).then((module) => ({ default: module.CreateGiftCardContainer }))
);
